export default "__VITE_ASSET__BrzKT9uI__"